import { Quote } from '../../types';

export async function loadQuotesByCategory(category: string): Promise<Quote[]> {
  try {
    const response = await import(`../../data/quotes/${category}.json`);
    return response.quotes || [];
  } catch (error) {
    console.error(`Error loading quotes for category ${category}:`, error);
    return [];
  }
}

export async function loadAllQuotes(): Promise<Quote[]> {
  const categories = ['inspiration', 'success', 'life', 'love', 'family', 'friendship', 'wisdom', 'peace'];
  const allQuotes: Quote[] = [];
  
  for (const category of categories) {
    const quotes = await loadQuotesByCategory(category);
    allQuotes.push(...quotes);
  }
  
  return allQuotes;
}

export async function loadCategories() {
  try {
    const response = await import('../../data/quotes/categories.json');
    return response.categories || [];
  } catch (error) {
    console.error('Error loading categories:', error);
    return [];
  }
}